<!--
 @description 服务监控-首页
 @author xiehan
 @date 2018/10/10
-->
<template>
  <div class="serverMonitor__content">
    <div class="mb-base">
      <span class="serverMonitor__siteName">{{ $t('logComponentManage.site') }}</span>
      <g-select class="serverMonitor__siteSelect" :list="siteList" v-model="siteCode"></g-select>
    </div>
    <div v-for="item in appList"
      :key="item.group"
      class="each-app"
      @click="jumpToApp(item.group)"
      :class="{ 'bg-green': item.level < 1 || item.level > 4,
      'bg-yellow': item.level >= 3 && item.level <= 4,
      'bg-red': item.level >= 1 && item.level <= 2}">
      <span v-text="item.group" :title="item.group" class="each-app-title"></span>
      <img :src="bgImg">
      <ul class="each-app-content">
        <li>
          <span v-text="$t('serverMonitor.appearAlarm')+item.realCount+$t('serverMonitor.unit')"></span>
        </li>
        <li>
          <span v-text="$t('serverMonitor.collectTarget')+item.fieldCount+$t('serverMonitor.unit')"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SiteListBiz from '@/logic/cmdb/cmdbBiz'
import ServerMonitorBiz from '@/logic/intelligentMonitor/serverMonitorBiz'
export default {
  data () {
    return {
      appList: [],
      bgImg: require('@/assets/image/monitor_bg.png'),
      siteList: {},
      siteCode: ''
    }
  },
  methods: {
    getSiteList () {
      SiteListBiz.siteList({perPageCount: 500}).then((data) => {
        let list = {}
        data.dataList.map((item) => {
          list[item.siteCode] = item.name
        })
        this.siteList = list
        this.siteCode = Object.keys(list)[0]
      })
    },
    getMonitorList (site) {
      ServerMonitorBiz.serverMonitor({ siteCode: site }).then((d) => {
        this.appList = d
      })
    },
    jumpToApp (group) {
      this.$router.push({ name: 'serverAppList', query: { group: group, siteCode: this.siteCode } })
    }
  },
  watch: {
    siteCode (val) {
      this.getMonitorList(val)
    }
  },
  mounted () {
    this.getSiteList()
  }
}
</script>

<style scoped>
  .serverMonitor__content .serverMonitor__siteName {
    font-weight: 700;
    font-size: 16px;
    padding: 0 10px;
  }
  .serverMonitor__content .serverMonitor__siteSelect {
    width: 200px;
  }
  .each-app {
    width: 224px;
    height: 110px;
    color: #fff;
    border-radius: 4px;
    display: inline-block;
    margin: 0 20px 20px 0;
    padding: 10px 0 0 15px;
    cursor: pointer;
    position: relative;
  }
  .each-app img {
    position: absolute;
    right: 0;
    bottom: 0px;
  }
  .each-app-title {
    font-size: 30px;
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-right: 15px;
    height: 40px;
  }
  .each-app-content {
    margin: 10px 0 0 20px;
  }
  .bg-green {
    background: #52b947;
  }
  .bg-yellow {
    background: #d4cf00;
  }
  .bg-red {
    background: #f27373;
  }
</style>
